const TRAINING_APP_DOMAIN = 'trainingApp'

const TRAINING_APP_KEY = {
  IS_API_IN_MAINTENANCE: 'isApiInMaintenance',
  IS_CHECKING_IOS: 'isCheckingIos',
  IS_CHECKING_ANDROID: 'isCheckingAndroid',
  UTM_SOURCE: 'utmSource',
  FROM_PLATFORM: 'fromPlatform'
}

const TRAINING_APP_PATH = {
  IS_API_IN_MAINTENANCE: `${TRAINING_APP_DOMAIN}.${TRAINING_APP_KEY.IS_API_IN_MAINTENANCE}`,
  IS_CHECKING_IOS: `${TRAINING_APP_DOMAIN}.${TRAINING_APP_KEY.IS_CHECKING_IOS}`,
  IS_CHECKING_ANDROID: `${TRAINING_APP_DOMAIN}.${TRAINING_APP_KEY.IS_CHECKING_ANDROID}`,
  UTM_SOURCE: `${TRAINING_APP_DOMAIN}.${TRAINING_APP_KEY.UTM_SOURCE}`,
  FROM_PLATFORM: `${TRAINING_APP_DOMAIN}.${TRAINING_APP_KEY.FROM_PLATFORM}`
}

const TRAINING_APP_ACTION = {
  UPDATE_IS_API_IN_MAINTENANCE: 'TRAINING_APP_UPDATE_IS_API_IN_MAINTENANCE',
  RESET_IS_API_IN_MAINTENANCE: 'TRAINING_APP_RESET_IS_API_IN_MAINTENANCE',
  UPDATE_IS_CHECKING_IOS: 'TRAINING_APP_UPDATE_IS_CHECKING_IOS',
  UPDATE_IS_CHECKING_ANDROID: 'TRAINING_APP_UPDATE_IS_CHECKING_ANDROID',
  UPDATE_UTM_SOURCE: 'TRAINING_APP_UPDATE_UTM_SOURCE',
  UPDATE_FROM_PLATFORM: 'TRAINING_APP_UPDATE_FROM_PLATFORM',
  UPDATE_SYSTEM: 'TRAINING_APP_UPDATE_SYSTEM',
  RESET_IS_CHECKING_IOS: 'TRAINING_APP_RESET_IS_CHECKING_IOS',
  RESET_IS_CHECKING_ANDROID: 'TRAINING_APP_RESET_IS_CHECKING_ANDROID'
}

const TRAINING_APP_STATE = {
  [TRAINING_APP_KEY.IS_CHECKING_IOS]: false,
  [TRAINING_APP_KEY.IS_CHECKING_ANDROID]: true,
  [TRAINING_APP_KEY.IS_API_IN_MAINTENANCE]: null,
  [TRAINING_APP_KEY.UTM_SOURCE]: null,
  [TRAINING_APP_KEY.FROM_PLATFORM]: null
}

export {
  TRAINING_APP_STATE,
  TRAINING_APP_PATH,
  TRAINING_APP_DOMAIN,
  TRAINING_APP_KEY,
  TRAINING_APP_ACTION
}
